import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { t } from 'i18next';

import { Xmark } from '@peacecover/icon';
import { useHandleHistoryBack } from '../../utils/useHandleHistoryBack';
import RegisterSalePhotoCard from './components/RegisterSalePhotoCard';
import type { TradingPhotoCardType } from './types/TradingPhotoCardType';
import { useSelectedTradingCardsStore } from './store/useSelectedTradingCardsStore';
import { postToOpener } from './utils/postToOpener';
import { POST_MESSAGES } from './constants/PostMessages';
import BottomCTA from './components/BottomCTA';

const RegisterSalePhotoCardsPage = () => {
  const navigate = useNavigate();

  const { selectedPhotoCards } = useSelectedTradingCardsStore();
  const [searchParams] = useSearchParams();

  const handleClick = () => {
    navigate(
      `/new-my-trading-photo-cards/register-sale-description?new=${searchParams.get('new') ?? 'false'}`
    );
  };

  // 카드가 하나도 없으면 오류 메시지 표시 후 카드 선택 초기화 및 페이지 닫기
  useEffect(() => {
    if (selectedPhotoCards.length === 0) {
      alert(t('NewTradingPhotoCards.emptyCardError'));
      postToOpener(POST_MESSAGES.clearSelectedTradingPhotoCards);
      window.close();
    }
  }, [selectedPhotoCards.length]);

  return (
    <main className="min-h-screen bg-pure-white dark:bg-background-dark pt-[calc(env(safe-area-inset-top))] pb-[calc(env(safe-area-inset-bottom))]">
      <RegisterSalePhotoCardsHeader />
      <div className="px-[24px]">
        <div className="flex flex-col gap-[14px] mt-[15px] py-[10px] leading-none">
          <h1 className="text-text-main-lv1 text-[26px] font-bold">
            {t('NewTradingPhotoCards.registerSalePhotoCardsPageTitle')}
          </h1>
          <p className="text-text-main-lv4 text-[15px] font-medium">
            {t('NewTradingPhotoCards.registerSalePhotoCardsPageDescription')}
          </p>
        </div>
        {selectedPhotoCards?.map((card: TradingPhotoCardType) => (
          <RegisterSalePhotoCard key={card.tradingPhotoCardId} card={card} />
        ))}
        <div className="h-[100px]" />
        <BottomCTA onClick={handleClick}>{t('next')}</BottomCTA>
      </div>
    </main>
  );
};

export default RegisterSalePhotoCardsPage;

const RegisterSalePhotoCardsHeader = () => {
  const handleHistoryBack = useHandleHistoryBack();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    handleHistoryBack();
  };
  return (
    <header className="flex items-center px-[16px] py-[15px]">
      <button type="button" onClick={handleClick}>
        <Xmark />
      </button>
    </header>
  );
};